import React, { useState, useEffect, useCallback } from "react";
import WrappedLoader from "../common/WrappedLoader";
import { useError } from "../../common/components/Errors";
import api from "../../common/lib/api";
import moment from "moment";
import numeral from "numeral";
import {Tag} from "@blueprintjs/core";

export default function Page() {
  const [state, setState] = useState({ status: "init" });
  const { errors, setErrors, handleError } = useError();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/broken-promises");
      setState({
        data: data.data,
        status: "ready",
      });
    } catch (e) {
      setState((current) => ({
        ...current,
        status: "error",
      }));
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <h1>Invoices for Broken Promises</h1>
      <WrappedLoader
        enabled
        state={state}
        errors={errors}
        setErrors={setErrors}
      >
        <p>The following table shows active invoices for broken promises (scan past).</p>
        <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-condensed bp3-interactive">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Invoice Date</th>
              <th>Customer</th>
              <th>Balance Due Amount</th>
              <th>End-of-Month Crediting Devices</th>
              <th>Inactive Devices</th>
            </tr>
          </thead>
          <tbody>
            {state.data &&
              state.data.map((row) => {
                return (
                  <tr key={row.number}>
                    <td>{row.number}</td>
                    <td>{moment(row.createdAt).format("YYYY-MM-DD")}</td>
                    <td>
                      <strong>
                        <pre>{row.shipToAddress}</pre>
                      </strong>
                      {row.lines.map((line) => {
                        return (
                          <p>
                            <strong>
                              {line.itemId}: {line.description}
                            </strong>
                            <DeviceIdList list={line.deviceIds} />
                          </p>
                        );
                      })}
                    </td>
                    <td>{numeral(row.balanceDueAmount).format('$0,0.00')}</td>
                    <td><DeviceIdList list={Object.values(row.toBeCredited).flat()} /></td>
                    <td><DeviceIdList list={row.stillInactive} /></td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </WrappedLoader>
    </>
  );
}

function DeviceIdList({ list }) {
  if (!list || !list.length) {
    return "";
  }

  return <div>{list.length} devices: {' '}
    {list.map(x => (<><Tag round>{x.toString()}</Tag>{' '}</>))}
  </div>;
}
